import React, { Component } from 'react';
import { FormGroup, Input, Button, Badge, Container, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import c from '../../constants/Colors';
import color from '../../constants/Colors';
import Pagination from '../reusable/Pagination'
import localStorageCustom from '../../utilitarios/localStorage';
import { BuscarProductoOfertas } from '../../store/sagas/pedidoApi';
import { AgregarProductoPedido } from '../../store/sagas/carritoApi';
import { AuthContext } from "../../store/provider/AuthProvider";
import { notificacion } from '../../utilitarios/util';
import { data } from '../../constants/Constants';
import ModalAddCart from "../reusable/modals/AddCart";
import ModalImageZoom from '../reusable/modals/ImageZoom';
import ModalCompatible from '../reusable/modals/Compatible';
import CardPrecioOferta from '../reusable/CardPrecioOferta';
import BtnCompatible from '../reusable/BtnCompatible';
import TooltipLeyenda from '../reusable/TooltipLeyenda';
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import Spinner from "../reusable/Loader";

const CardOferta = ({ item, postAgregarProductoPedido, postAgregarProductoFavorito, setCounter, auth, compatible }) => {
  return (
    <div className="card_product_horizontal card_oferta" style={{ backgroundColor: c.morado }}>
      <div className="cphTextLeft">
        <div className="tag">
          <SvgAssets icon="icon-oferta" fill={c.rojoClaro} className="icon-oferta" />
          <SvgAssets icon="icon-tag" />
        </div>
        <h6 className="paragraph-2 bold mb-1 mt-4" style={{ color: '#fff', wordBreak: 'break-word' }}>{item.maktx}</h6>
        <span className="paragraph-3 mb-3" style={{ color: '#fff' }}>SKU: {item.matnr}</span>
        <span className="paragraph-3" style={{ color: '#fff' }}>Total: {item.sWaers} {item.subTotal.toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
      </div>
      <div className="cphTextCenter pl-0">
        <CardPrecioOferta data={item.precios} className="cardPrice mt-4" />
        <div className="options">
          {/* <BtnCompatible IdInput={item.idInput} texto={item.mensajeCompatible} /> */}
          <button className='btn-icon'
            type="button"
            onClick={() => compatible(item.mensajeCompatible)}
          >
            <SvgAssets icon="icon-compatible" fill={c.azulClaro} />
          </button>
          <button className="btn-icon"
            onClick={() => postAgregarProductoFavorito({
              codigo: item.matnr, descripcion: item.maktx,
              moneda: item.waers, pantalla: data.Pantalla.Catalogo.Ofertas
            }, item.favorito, item.indice)}
          >
            <SvgAssets icon="icon-star" fill={item.favorito ? color.amarillo : color.celeste} />
          </button>
          <button className='btn-icon'
            type="button"
            disabled={item.cantidad == 0}
            onClick={() => postAgregarProductoPedido(auth.carritoProdctos, auth.setcarritoProdctos, item, data.Pantalla.Catalogo.Ofertas)}
          >
            <SvgAssets icon="icon-add-cart" />
          </button>
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: '#8886ff', justifyContent: 'space-between' }}>
        <span className="paragraph-3" style={{ color: '#fff' }}>Cantidad</span>
        <CounterInput
          vertical
          background={'transparent'}
          color={"#fff"}
          borderColor={"#fff"}
          data={item}
          eventCounter={setCounter}
        />
      </div>
    </div>
  )
}

export class Ofertas extends Component {
  static displayName = Ofertas.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dealer: {},
      linea: {},
      asociado: {},
      productosOfertas: [],
      // productosOfertasFiltrados: [],
      page: 1,
      size: data.PageSizeOfertas,
      currentPage: 1,
      totalPorCantidad: null,
      addToCart: false,
      dataToCard: {},
      textBuscador: "",
      errorCodigo: false,
      modalZoom: false,
      modalCompatible: false,
      mensajeCompatible: '',
      imgZoom: "",
    };
  }

  load = async () => {
    let data = localStorageCustom.prototype.getUsuario();
    this.setState({ errorCodigo: false, textBuscador: "", page: 1, dealer: data.dealer, linea: data.linea, asociado: data.asociado }, async () => {
      this.postListarOfertasTop(data.dealer, data.linea, data.asociado, 1);
    })
  }

  showModalCart = () => {
    this.setState(prevState => ({
      addToCart: !prevState.addToCart
    }));
  }
  toggleModalCompatible = (texto) => {
    this.setState(prevState => ({
      modalCompatible: !prevState.modalCompatible,
      mensajeCompatible: texto
    }));
  }
  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: img
    }));
  }
  // showCarrito = () => {
  //   this.setState({ addToCart: false, loading: false }, () => {
  //     this.props.history.push('/carrito');
  //   });
  // }
  showCarrito = () => {
    this.setState({ addToCart: false, loading: true }, () => {
      setTimeout(() => {
        this.setState({ loading: false })
        this.props.history.push('/carrito');
      }, 1000);
    });
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    this.load();
    // let data = localStorageCustom.prototype.getUsuario();
    // this.setState({ dealer: data.dealer, linea: data.linea, asociado: data.asociado }, () => {
    //   this.postBuscarProductoOfertas(data.dealer, data.linea, data.asociado);
    // })
  }

  IrBuscar = () => {
    if (this.state.textBuscador == "" || this.state.textBuscador.length >= data.BuscadorCodigoLongitud) {
      this.setState({
        errorCodigo: false,
        loading: true,
        page: 1
      }, async () => {
        this.postListarOfertasTop(this.state.dealer, this.state.linea, this.state.asociado, 1);
      })
    } else {
      this.setState({
        errorCodigo: true
      })
    }
  }

  postAgregarProductoFavorito = async (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito
    )
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          let _productosOfertas = this.state.productosOfertas
          _productosOfertas[index].favorito = !AplicaFavorito;

          this.setState({
            productosOfertas: _productosOfertas
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Ofertas", error.message ?? null);
        });
      });
  }

  postListarOfertasTop(dealer, linea, asociado, index) {
    this.setState({ loading: true })
    BuscarProductoOfertas(linea.vkorg, dealer.codcliente,
      dealer.correoElectronico, asociado.poblacion, asociado.moneda, linea.centro,
      data.Sistema, this.state.size, index, this.state.textBuscador)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            productosOfertas: result.dto.repuestos,
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false, productosOfertas: [] }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }

  render() {
    const { textBuscador, errorCodigo, loading, productosOfertas, page, size, currentPage } = this.state;
    const auth = this.context;
    return (
      <div className="bg_white" style={{ minHeight: 'calc(100vh - 69px)' }}>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Productos en oferta</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/dashboard' style={{ pointerEvents: 'none' }}>Catálogo de Repuestos</Link></li>
              <li><Link to='/Ofertas' style={{ pointerEvents: 'none' }}>Ofertas</Link></li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <div className="card_desktop">
            <TooltipLeyenda
              color={c.azulClaro}
              style={{ marginLeft: 'auto', top: -15, position: 'relative', width: 'max-content' }}
            />
            <FormGroup className="icon mb-4" style={{ maxWidth: 255, margin: 'auto' }}>
              <Input className="" type='text' placeholder="SKU o Descripción" onChange={(text) => this.searchProductos(text)}
                onKeyUp={(e) => { if (e.keyCode == 13 || e.keyCode == 10) { e.preventDefault(); this.IrBuscar() } }}
              />
              <Button color="link" className="btn-icon" onClick={() => { this.IrBuscar() }}>
                <SvgAssets icon='icon-lupa' fill={c.azulClaro} />
              </Button>
            </FormGroup>
            <hr className="desktop mb-5" style={{ borderColor: '#E2E2E2' }} />
            <h6 className="title white mobile">Productos en oferta</h6>
            <div className="cards-wrap">
              {productosOfertas != null ?
                productosOfertas.map((item, index) => {
                  return (
                    <CardOferta item={item} key={index} postAgregarProductoPedido={this.postAgregarProductoPedido} postAgregarProductoFavorito={this.postAgregarProductoFavorito} setCounter={this.setCounter} auth={auth} compatible={this.toggleModalCompatible} />
                  );
                })
                : null
              }
            </div>
            {/* <Pagination /> */}
            {(productosOfertas.length > 0) ?
              <Pagination
                event={this.setPage}
                current={page}
                currentPage={currentPage}
                totalPage={productosOfertas[0].totalPage}
                size={data.PageSizePaginator} /> : null}
          </div>
        </Container>
        <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
        <ModalImageZoom dadComponent={this} />
        <ModalCompatible dadComponent={this} texto={this.state.mensajeCompatible} />
      </div>
    );
  }

  searchProductos = (e) => {
    let text = e.currentTarget.value;

    this.setState({ textBuscador: text });
  }

  setPage = (index, change, type) => {
    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({ page: index, currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1) })
    }
    else
      this.setState({ page: index })

    this.postListarOfertasTop(this.state.dealer, this.state.linea, this.state.asociado, index);
  }

  setCounter = (counter, item, index) => {

    let _destacados = this.state.productosOfertas
    if (counter == "") {
      _destacados[index].cantidad = 0;
    } else {
      _destacados[index].cantidad = counter;
      _destacados[index].subTotal = Number((_destacados[index].pfinal * counter).toFixed(2));
    }

    this.setState({
      productosOfertas: _destacados
    })
  }

  postAgregarProductoPedido = async (carritoProdctos, setcarritoProdctos, item, pantalla) => {
    debugger;
    this.setState({ loading: true })

    let producto = {
      codigo: item.matnr,
      descripcion: item.maktx,
      precioOferta: item.pOfe,
      precioPublico: item.pPub,
      precioFinal: item.pFin,
      precioPVD: item.precioPVD,
      precioPVP: item.precioPVP,
      precioPublico: item.precioPublico,
      meins: item.meins,
      moneda: item.waers,
      cantidadOriginal: item.cantidad,
      cantidad: item.cantidad,
      pantalla: pantalla,
      pathI: item.pathImage,
      precios: item.precios,
      escalas: item.escalas
    };

    AgregarProductoPedido(this.state.dealer, producto, this.state.linea, this.state.asociado)
      .then(result => {
        if (result.mo.type == "success") {
          let _destacados = this.state.productosOfertas
          _destacados[item.indice].cantidad = 0;
          _destacados[item.indice].subTotal = 0;
          this.setState({
            loading: false,
            addToCart: true,
            dataToCard: producto,
            productosOfertas: _destacados,
          })
          // setcarritoProdctos(carritoProdctos + 1)
          setcarritoProdctos(result.dto.carritoProdctos);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }
}
